module.exports = __webpack_public_path__ + "static/media/wilson.b682e261.jpg";